import api from './api';
import type { DaySummaryResponse } from '../types/api';

/** Per-day financials grouped per vehicle plate by direction (to/from the hub). */
export async function getDaySummary(date?: string): Promise<DaySummaryResponse> {
  const { data } = await api.get<DaySummaryResponse>('/finance/day-summary/', {
    params: date ? { date } : undefined,
  });
  return data;
}
